import { Box, Typography, Stack } from '@mui/material';
import ImageWithValidate from '../../../../common/input/image-with-validate';
import { PlayFormData } from '../../types';
import { MediaInfoBox } from './MediaInfoBox';

interface PlayLogoSectionProps {
  teamAbbrv: string;
  playLogo: string;
  onPlayLogoChange: (value: string) => void;
}

export function PlayLogoSection({ teamAbbrv, playLogo, onPlayLogoChange }: PlayLogoSectionProps) {
  const handleValueChange = (name: keyof PlayFormData, value: string) => {
    if (name === 'playLogo') {
      onPlayLogoChange(value);
    }
  };

  return (
    <Stack direction="row" spacing={4} sx={{ p: 3 }}>
      <Box sx={{ flex: 1 }}>
        <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 600 }}>
          Play Logo
        </Typography>
        <ImageWithValidate<PlayFormData>
          storagePath={`fotbollplay/${teamAbbrv}`}
          name="playLogo"
          value={playLogo}
          onValue={handleValueChange}
        />
      </Box>
      <MediaInfoBox>
        Logotypen som visas i Play-sektionen. Rekommenderad storlek är 200x200 pixlar. Använd en
        transparent PNG för bästa resultat.
      </MediaInfoBox>
    </Stack>
  );
}
